import ApiSetting from '@/request/api/setting'
import axios from '@/request/http'
// import querystring from 'querystring'

const latestEpisodesConfigApi = {
  list (params) {
    return axios.get(`${ApiSetting.baseUrl}/api/latestepisodes-config/`, {params: params})
  },
  detail (latestEpisodesConfigId, params) {
    return axios.get(`${ApiSetting.baseUrl}/api/latestepisodes-config/${latestEpisodesConfigId}/`, {params: params})
  }
}

export default latestEpisodesConfigApi
